import React, { useMemo } from 'react';

import { DateFormat } from '@blockworks/ui/legacy/datetime';
import { CompactPrice } from '@blockworks/ui/legacy/numbers';

import Tabs from '@/components/display/tabs/tabs';
import { ETFEntity } from '@/components/pages/etf/layout/components/etf-page-table';

export type Asset = {
    code: string;
    title: string;
    imageUrl: string;
};

type Props = {
    lastUpdated?: number;
    asset: Asset;
    etfs: ETFEntity[];
};
// eslint-disable-next-line import/prefer-default-export

const tabs = [
    { name: 'Bitcoin ETF Tracker', href: '/bitcoin-etf' },
    {
        name: 'Ethereum ETF Tracker',
        href: '/ethereum-etf',
    },
];
const EtfPageLayout = (props: Props) => {
    const { asset, lastUpdated } = props;

    const totalVolume = useMemo(
        () => props.etfs.reduce((acc, etf) => acc + Number(etf.volume ?? 0) * (etf.price ?? 0), 0),
        [props.etfs],
    );
    const totalMarketCap = useMemo(
        () => props.etfs.reduce((acc, etf) => acc + Number(etf.marketCap ?? 0), 0),
        [props.etfs],
    );

    return (
        <div>
            <div className="relative flex items-center space-x-3 border-b pb-6 gap-0">
                <div className="flex-shrink-0">
                    <img className="h-10 w-10 rounded-full" src={asset.imageUrl} alt="" />
                </div>
                <div className="min-w-0 flex-1">
                    <h1 className="font-semibold text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl text-left text-gray-900">
                        {asset.title} ETF Tracker
                    </h1>
                    <div className="truncate text-sm text-gray-500 flex flex-row gap-1">
                        {totalVolume === 0 && totalMarketCap === 0 && <p>{asset.code}</p>}
                        {totalVolume > 0 && (
                            <div className="flex gap-1">
                                <p>
                                    24h Volume:{' '}
                                    <span className="font-bold">
                                        <CompactPrice price={totalVolume} />
                                    </span>
                                </p>
                            </div>
                        )}
                        {totalMarketCap > 0 && (
                            <div className="flex gap-1">
                                <p>|</p>
                                <p>
                                    Total Marketcap:{' '}
                                    <span className="font-bold">
                                        <CompactPrice price={totalMarketCap} />
                                    </span>
                                </p>
                            </div>
                        )}
                    </div>
                </div>
                <div className="pr-4 hidden md:flex">
                    <Tabs tabs={tabs} hideActive className="m-0" />
                </div>
                {lastUpdated && (
                    <div className="text-xs align-top text-right px-3 py-2 hidden md:flex flex-col">
                        <p className="text-gray-400">Last update:</p>
                        <span className="text-gray-400">
                            <DateFormat dateStringOrTimestamp={lastUpdated} format="LLL d, yyyy - h:mm a" />
                        </span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default EtfPageLayout;
